import { PaginatedColumn } from '../types/app';

export const TABLE_COLUMNS_NAME: PaginatedColumn[] = [
  {
    label: 'Nombre',
    key: 'name',
  },
  {
    label: 'Descripción',
    key: 'description',
  },
  {
    label: 'Tipo de activación',
    key: 'triggerType',
    minWidth: 150,
    maxWidth: 150,
  },
  {
    label: 'Valor de activación',
    key: 'trigger',
    minWidth: 150,
    maxWidth: 150,
  },
  {
    label: 'Tipo de mantenimiento',
    key: 'maintenanceType',
  },
  {
    label: 'Acciones',
    key: 'actions',
    minWidth: 120,
    maxWidth: 120,
    centered: true,
  },
];
